/**
 * SLA lead-time register (construction Phase 2): agreed days from call-off to
 * delivery per supplier, optionally per commodity. Customer maintains it, the
 * supplier reads its own rows. Backend: `/api/v1/barratt/lead-times/`.
 */
import api, { type AxiosResponse, type PaginatedResponse } from './client';

export interface SupplierLeadTime {
  id: number;
  customer: number;
  customer_name: string;
  supplier: number;
  supplier_name: string;
  /** Blank = the supplier's default for every commodity. */
  commodity_code: string;
  commodity_name: string;
  lead_time_days: number;
  effective_from: string;
  effective_to: string | null;
  notes: string;
  is_current: boolean;
  created_at: string;
  updated_at: string;
}

export interface SupplierLeadTimePayload {
  supplier: number;
  commodity_code: string;
  lead_time_days: number;
  effective_from: string;
  effective_to?: string | null;
  notes?: string;
}

export interface LeadTimeCommodity {
  code: string;
  name: string;
}

export const leadTimesAPI = {
  list: (params?: Record<string, string | number | boolean>): Promise<AxiosResponse<PaginatedResponse<SupplierLeadTime>>> =>
    api.get('/barratt/lead-times/', { params }),
  create: (data: SupplierLeadTimePayload): Promise<AxiosResponse<SupplierLeadTime>> =>
    api.post('/barratt/lead-times/', data),
  update: (id: number, data: Partial<SupplierLeadTimePayload>): Promise<AxiosResponse<SupplierLeadTime>> =>
    api.patch(`/barratt/lead-times/${id}/`, data),
  remove: (id: number): Promise<AxiosResponse<void>> => api.delete(`/barratt/lead-times/${id}/`),
  commodities: (): Promise<AxiosResponse<LeadTimeCommodity[]>> => api.get('/barratt/lead-times/commodities/'),
};
